export default "__VITE_ASSET__BQufqeWx__"